<template>
  <div class="AddGroupManage">
    <van-nav-bar
      title="删除群管理员"
      fixed
      @click-left="onClickLeft"
      right-text="删除"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="manage">
      <van-checkbox class="all" v-model="checked" type="info" @click="toggleAll">全选</van-checkbox>
      <van-checkbox-group v-model="result" ref="checkboxGroup">
        <van-checkbox
          :name="item.users.u_id"
          v-for="(item,index) in groupManage"
          :key="index+'a'"
          v-if="item.users.u_id != ug_id"
        >
          <!-- {{item}} -->
          <van-cell
            border
            :title="item.users.ug_group_nick?item.users.ug_group_nick:item.users.u_nickname?item.users.u_nickname:item.users.u_login_id"
          >
            <van-image
              slot="icon"
              class="err-image-header"
              round
              :src="attach_url+item.users.u_headportrait"
            />
          </van-cell>
        </van-checkbox>
        <!-- {{groupManage}} -->
      </van-checkbox-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "DelGroupManage",
  data() {
    return {
      ug_id: "",
      groupManage: "",
      checked: false,
      result: [],
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre
    };
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.ug_id = params.ug_id;
    this.loadData();
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    loadData() {
      var params = {
        ug_group_id: this.ug_id,
        token: this.token,
        u_id: this.u_id,
        num: Math.random()
      };
      var url = this.Conf.serverUrl + "Groups/getGroupManageUserInfo";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          console.log("show", response);
          if (response.data.code == 200) {
            // this.groupManage = response.data.data[0].users;
            this.groupManage = response.data.data;
            //  console.log("hhhh",this.groupManage )
          }
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "ShowGroupManage",
        query: {
          ug_id: this.ug_id
        }
      });
    },
    onClickRight() {
      var params = {
        u_id: this.u_id,
        token: this.token,
        ug_user_id: this.result,
        ug_group_id: this.ug_id
      };
      console.log("111", this.result);
      var url = this.Conf.serverUrl + "Groups/upGroupManage";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          console.log("hhhhh", response);
          switch (response.data.code) {
            case 200:
              this.$toast.success(response.data.msg);
              this.onClickLeft();
              break;
            case 40001:
              this.$toast.fail(response.data.msg);
              break;
          }
        })
        .catch(error => {});
    },
    // 全选
    toggleAll() {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(false);
      } else {
        this.$refs.checkboxGroup.toggleAll(true);
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Group/DelGroupManage.vue